<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb page-title="Carga Masiva de Datos" :icon="'upload'" />
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 col-md-6">
                <form  ref="form" class="mb-0"
                        data-url="/masterData/uploadata"
                        enctype="multipart/form-data"
                        :class="{'loading-opacity': preloader}"
                >

                    <fieldset class="form-group">

                        <div class="form-row">
                            <div class="col-md-12">
                                <div class="form-group mb-2">
                                    <label>{{ $t('Tipo de Datos') }}</label>
                                    <app-input type="select"
                                            v-model="inputs.type"
                                            :required="true"
                                            :list="dataList"/>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-md-12">
                                <div class="form-group mb-2">
                                    <label>{{ $t('Archivo') }}</label>
                                        <app-input type="file"
                                                :label="fileLabel"
                                                v-model="inputs.file"
                                                v-on:change="fileChoosen"
                                                :required="true"/>
                                        <br>
                                        <small class="form-text text-muted">Solo se aceptan archivos de tipo .xls, .xlsx de máximo 8MB</small>
                                </div>
                            </div>
                        </div>

                    </fieldset>


                    <div class="mt-5">
                        <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                            <i data-feather="edit" class="pr-2"/>Enviar
                        </button>
                    </div>

                </form>
            </div>
        </div>


    </div>
</template>

<script>
    import CoreLibrary from "@/core/helpers/CoreLibrary.js";
    import * as actions from "../../apiUrl";
    import { FormMixin } from "@/core/mixins/form/FormMixin.js";

    export default {
        extends: CoreLibrary,
        mixins: [FormMixin],
        data() {
            return {
                preloader: false,
                inputs: {},
                fileLabel: "Seleccionar Archivo",
                dataList: [
                    {
                        id: 1,
                        value: "",
                    },
                    {
                        id: 0,
                        value: "NO",
                    },
                ],
            };
        },
        created() {
            if (this.selectedUrl) {
                this.preloader = true;
            }
        },
        methods: {
            fileChoosen(event) {
                console.log(event.target.files[0].type);
                if (['application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.oasis.opendocument.spreadsheet'].includes(event.target.files[0].type)) {
                    if (event.target.files[0].size < 5111775) {
                        if (event.srcElement.id === "inputs_file") {
                            this.fileLabel = event.target.files[0].name;
                        }
                    } else {
                    this.$toastr.e("El archivo PDF no debe exceder los 5MB.");
                    }
                } else {
                    this.$toastr.e("Solo permitidos archivos .xls y .xlsx");
                }
            },
            submit() {
                this.save(this.inputs);
            },
            afterSuccess(response) {
                if (this.selectedUrl != "") {
                    this.$toastr.s(this.$t("updated_success"));
                } else {
                    this.$toastr.s(this.$t("created_success"));
                }
                this.$hub.$emit("reload-" + this.tableId);
            },
            afterSuccessFromGetEditData(response) {
                this.inputs = response.data;
                this.preloader = false;
            },
            afterFinalResponse() {
                this.closeModal();
                this.preloader = false;
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
        },
    };
</script>